import ahoy from 'ahoy.js'

process.env.RAILS_ENV !== 'production' && ahoy.debug()
ahoy.configure({ trackVisits: process.env.RAILS_ENV !== 'test' })
ahoy.start()

export default ahoy
